import router from "@/router"
export function useRoutingToVue(composantName, params = {}, query = {}) {
    router.push({
        name: composantName,
        params: params,
        query: query,
    })
}
